<mat-form-field appearance="outline"
    class="customFormField"
    [ngStyle]="{
        'margin-bottom': marginBottom,
        'width': fullWidth ? '100%' : 'inherit'
    }"
	style="min-width: inherit; max-width: inherit;"
    [color]="color"
    [floatLabel]="floatLabel"
    [hintLabel]="hintLabel"
    [hideRequiredMarker]="hideRequiredMarker">

    <!-- Accessory Handling -->
    <mat-label *ngIf="label && required" style="max-width: 90%; text-overflow: ellipsis; overflow: hidden; display: block; white-space: nowrap;">
        <span *ngIf="!postLabelSpace">{{label | translate}}</span>         
        <span *ngIf="postLabelSpace">{{label | translate}}&nbsp;</span>         
    </mat-label>
    <mat-label *ngIf="label && !required">
        <span *ngIf="!postLabelSpace">{{label | translate}}</span>         
        <span *ngIf="postLabelSpace">{{label | translate}}&nbsp;</span>         
    </mat-label>
    <mat-hint *ngIf="hintAlign == 'start' && hint"
		[ngStyle]="{'color': hintColor}"
        align="start">
        {{hint | translate}}
    </mat-hint>
    <mat-hint *ngIf="hintAlign == 'end' && hint"
		[ngStyle]="{'color': hintColor}"
        align="end">
        {{hint | translate}}
    </mat-hint>
    <mat-error *ngIf="showErrorMessage == true" [id]="(control && control.id ? control.id : '') + 'Error'">{{errorMessage | translate}}</mat-error>
    <div matPrefix>
        <ng-content select="[matPrefix]"></ng-content>
    </div>
    <div matSuffix>
        <ng-content select="[matSuffix]"></ng-content>
		<ng-container *ngIf="clearable && hovering && control.value">
			<button mat-icon-button
				color="warn"
				(click)="clear()"
				[attr.id]="label + 'ClearButton'">
				<mat-icon aria-hidden="true">
					clear
				</mat-icon>
			</button>
		</ng-container>
    </div>

    <!-- Control Handling -->
    <ng-content select=[matInput]></ng-content>
    <ng-content select="mat-select"></ng-content>
    <ng-content select="mat-chip-list"></ng-content>
</mat-form-field>
